import {ErrorHandler, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer, provideZoneChangeDetection} from '@angular/core';
import {PreloadAllModules, provideRouter, Router, RouteReuseStrategy, withPreloading} from '@angular/router';
import {registerLocaleData} from '@angular/common';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {bootstrapApplication} from '@angular/platform-browser';
import {authInterceptor} from './app/Core/Interceptors/auth.interceptor';
import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {IonicStorageModule} from '@ionic/storage-angular';
import {environment} from './environments/environment';
import {routes} from './app/app.routes';
import {AppComponent} from './app/app.component';
import {GlobalErrorHandler} from './app/Core/Handlers/global-error.handler';
import localeEs from '@angular/common/locales/es';
import packageJson from '@packageJson';
import * as Sentry from '@sentry/angular';

registerLocaleData(localeEs);

if (environment.production) {

  Sentry.init({
    dsn: 'https://88079faf738a13c82ac03e895c03139b@sentry.yurest.dev/13',
    environment: 'production',
    release: `yurest_prov_v2@${packageJson.version}`,
    dist: packageJson.version,
    integrations: [Sentry.browserTracingIntegration({enableInp: true})],
    tracesSampleRate: 0.1,
  });

}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      IonicStorageModule.forRoot(),
      IonicModule.forRoot({
        mode: 'ios',
        backButtonText: '',
        backButtonDefaultHref: '',
        innerHTMLTemplatesEnabled: true,
      })
    ),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor])),
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: Sentry.TraceService, deps: [Router]},
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
}).catch((err) => console.error(err));
